import { getField, updateField } from 'vuex-map-fields'

import Mtxs from '@/constants/Mutations'

export const state = {
  showAccountCreatedSnackbar: false,
  showAccountUpdatedSnackbar: false,
  showLoggedOutSnackbar: false,
  showPasswordUpdatedSnackbar: false,
  showRecordDeletedSnackbar: false,
  showEmailVerifiedSnackbar: false,
  showRecordClonedSnackbar: false,
  showMenuRearrangedSnackbar: false,
  showExportSuccessSnackbar: false,
}
export const mutations = {
  [Mtxs.SET_ACCOUNT_CREATED_SNACKBAR](state, visibility) {
    state.showAccountCreatedSnackbar = visibility
  },
  [Mtxs.SET_ACCOUNT_UPDATED_SNACKBAR](state, visibility) {
    state.showAccountUpdatedSnackbar = visibility
  },
  [Mtxs.SET_AUTH_LOGGED_OUT_SNACKBAR](state, visibility) {
    state.showLoggedOutSnackbar = visibility
  },
  updateField,
}
export const getters = {
  getShowAccountCreatedSnackbar: (state) => state.showAccountCreatedSnackbar,
  getShowAccountUpdatedSnackbar: (state) => state.showAccountUpdatedSnackbar,
  getShowLoggedOutSnackbar: (state) => state.showLoggedOutSnackbar,
  getField,
}
export const actions = {
  setAccountCreatedSnackbar({ commit }, visibility) {
    commit(Mtxs.SET_ACCOUNT_CREATED_SNACKBAR, visibility)
  },
  setAccountUpdatedSnackbar({ commit }, visibility) {
    commit(Mtxs.SET_ACCOUNT_UPDATED_SNACKBAR, visibility)
  },
  setLoggedOutSnackbar({ commit }, visibility) {
    commit(Mtxs.SET_AUTH_LOGGED_OUT_SNACKBAR, visibility)
  },
}
